






























import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'c-dlg-wrapper'
})
export default class DlgWrapper extends Vue {
  dialog: boolean = false
  resolve: any = null
  reject: any = null

  protected open (): Promise<boolean> {
    this.dialog = true

    return new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }

  protected del (): void {
    this.resolve(true)
    this.dialog = false
  }

  protected cancel (): void {
    this.resolve(false)
    this.dialog = false
  }

  provide () {
    return {
      agree: (this as any).agree,
      cancel: this.cancel
    }
  }
}
